export default (num: number | null | undefined): string => {
  if (!num && num !== 0) {
    return '-'
  }
  const rounded: number = num / 100

  let result = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    useGrouping: true,
  }).format(rounded)

  result = result.replace(',00', '').replace(/\u00A0/g, ' ')

  return result
}
